;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React, { useEffect, useCallback } from "react"
import useEmblaCarousel from "embla-carousel-react"

import styles from "./styles.module.scss"
import map from "lodash/map"

const EmblaCarouselTitle = ({
  quotes,
  page,
  handleChangePage,
  setInactiveGrayScale,
}) => {
  const [viewportRef, embla] = useEmblaCarousel({
    skipSnaps: false,
    loop: true,
    slidesToScroll: 1,
  })

  const onSelect = useCallback(() => {
    if (!embla) return
    const currentSnappedPage = embla.selectedScrollSnap()
    if (currentSnappedPage !== page) {
      handleChangePage(embla.selectedScrollSnap())
    }
  }, [embla, page, handleChangePage]) // Include handleChangePage in the dependency array

  useEffect(() => {
    if (!embla) return

    onSelect()
    embla.on("select", onSelect)
    embla.scrollTo(page)

    return () => {
      embla.off("select", onSelect) // Proper cleanup
    }
  }, [embla, page, onSelect])

  const renderUserTitle = ({ title }) => {
    return <div className={styles["user-title"]}>{title}</div>
  }

  return (
    <div className={styles["embla"]}>
      <div className={styles["embla__viewport"]} ref={viewportRef}>
        <div className={styles["embla__container"]}>
          {map(quotes, ({ title }, index) => (
            <div className={styles["embla__slide"]} key={index}>
              <div
                className={styles["embla__slide__inner"]}
                onMouseEnter={() => setInactiveGrayScale(true)}
                onMouseLeave={() => setInactiveGrayScale(false)}
              >
                {renderUserTitle({ title })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default EmblaCarouselTitle
